import * as React from 'react';
import { SyntheticEvent } from 'react';
// import Toggle from './Toggle';
import '../../../styles/Checkbox.css';
// import AccordionArrow from './AccordionArrow';
import Toggle from './Toggle';

export interface CheckboxProps {
    inputProps: {
        id: string;
        name: string;
        required?: boolean;
        checked: boolean;
        disabled?: boolean;
        readOnly?: boolean;
    };
    toggle?: boolean;
    onChange: (inputName: string, newValue: boolean) => void;
    controlCssClass?: string;
    styledCheckbox?: boolean;
}

const Checkbox = (props: CheckboxProps) => {
    const checkChanged = (e: SyntheticEvent<HTMLInputElement>) => {
        props.onChange(props.inputProps.name, e.currentTarget.checked);
    };
    return props.toggle ? (
        <Toggle
            checked={props.inputProps.checked}
            onChange={value => props.onChange(props.inputProps.name, value)}
        />
    ) : props.styledCheckbox ? (
        <label className="styled-checkbox-container">
            <input type="checkbox" {...props.inputProps} onChange={checkChanged} />
            <span className="checkmark" />
        </label>
    ) : (
        <input type="checkbox" {...props.inputProps} onChange={checkChanged} />
    );
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/common/form/Checkbox.tsx